export default "__VITE_ASSET__B_XEjW9C__"